<script setup lang="ts">
import VuBtn from '@v/components/vu-btn.vue';

type SideBtnProps = {
  name?: string;
  ariaLabel?: string;
};

const props = withDefaults(defineProps<SideBtnProps>(), {
  name: '',
  ariaLabel: '',
});
</script>
<template>
  <div class="side-button scale-in">
    <vu-btn
      :name="props.name"
      :aria-label="props.ariaLabel"
      class="flex align-items-center justify-center fade-keyframe btn btn-default"
    >
      <slot />
    </vu-btn>
  </div>
</template>

<style scoped lang="scss">
@use '/assets/scss/variables' as variables;

$size_normal: 40px;
$size_xl: 50px;

.side-button {
  position: fixed;
  bottom: 60px;
  right: 21px;
  z-index: 2;

  .btn {
    transition: transform 0.3s ease;
    display: flex;
    width: $size_xl;
    min-width: $size_xl;
    height: $size_xl;
    border-radius: 50px;
    padding: 0;
    margin: 0;
    box-shadow: 0 2px 4px darkslategray;
    cursor: pointer;

    @include variables.for-md {
      width: $size_normal;
      min-width: $size_normal;
      height: $size_normal;
      border-radius: $size_normal;
    }
  }

  @media (hover: hover) {
    &:hover {
      .btn {
        transform: scale(1.1);
      }
    }
  }

  :deep(.fonticon) {
    margin: 0;
    font-size: calc(#{$size_xl} / 2);
    width: calc(#{$size_xl} / 2);

    @include variables.for-md {
      font-size: calc(#{$size_normal} / 2);
      width: calc(#{$size_normal} / 2);
    }
  }
}
</style>
